module.exports = __webpack_public_path__ + "img/motorola.199693d3.svg";